import { useMutation, useQueryClient } from "@tanstack/react-query"
import { createCriteria } from "../../services/criteria";
import { IIndicators } from "../../types/indicator";
import { toast } from "react-toastify";

const useCreateCriteria = (indicator: IIndicators) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: createCriteria,
        onMutate: () => {
            indicator.setIsProcessRunning(true);
            indicator.setIsServiceError(null);
        },
        onSuccess: (status) => {
            if (status === 200) {
                queryClient.invalidateQueries({ queryKey: ['criteria-groups'] });
                indicator.setIsProcessRunning(false);
                indicator.setIsServiceError(null);
                toast.success("Criteria created successfully");
            }
        },

        onError: (error: any) => {
            indicator.setIsServiceError(error?.response?.data?.message);
            indicator.setIsProcessRunning(false);
            toast.error(error?.response?.data?.message);
        }
    });
};

export default useCreateCriteria;